'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _SafeAnchor = require('../SafeAnchor');

var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);

var _safeAttributes = require('../utils/safeAttributes');

var _safeAttributes2 = _interopRequireDefault(_safeAttributes);

var _bootstrapUtils = require('../utils/bootstrapUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CARET = _react2.default.createElement(
  'span',
  null,
  ' ',
  _react2.default.createElement('span', { className: 'caret' })
);

var DropdownToggle = function (_React$Component) {
  _inherits(DropdownToggle, _React$Component);

  function DropdownToggle() {
    _classCallCheck(this, DropdownToggle);

    return _possibleConstructorReturn(this, (DropdownToggle.__proto__ || Object.getPrototypeOf(DropdownToggle)).apply(this, arguments));
  }

  _createClass(DropdownToggle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          noCaret = _props.noCaret,
          useAnchor = _props.useAnchor,
          theme = _props.theme,
          bootstrapClass = _props.bsClass,
          props = _objectWithoutProperties(_props, ['noCaret', 'useAnchor', 'theme', 'bsClass']);

      var caret = noCaret ? null : CARET;

      var classes = _defineProperty({}, (0, _bootstrapUtils.prefix)(this.props, 'toggle'), true);

      var Component = useAnchor ? _SafeAnchor2.default : _Button2.default;

      var validProps = (0, _safeAttributes2.default)(props);
      if (theme === 'helix') {
        return this.props.dropdownType === 'icon' ? _react2.default.createElement(
          'label',
          _extends({}, validProps, {
            className: (0, _classnames2.default)("helix-dropdown__options-label", { "helix-dropdown__options-label--disabled": this.props.disabled }) }),
          this.props.children
        ) : _react2.default.createElement(
          'a',
          _extends({}, validProps, {
            className: (0, _classnames2.default)("helix-dropdown__label uppercase", { "helix-dropdown__toggler--open": this.props.open }, { "disabled": this.props.disabled }) }),
          this.props.children,
          _react2.default.createElement('span', { className: 'fa helix-dropdown__caret' })
        );
      }
      if (this.props.dropdownType === 'navigation') {
        return _react2.default.createElement(
          'a',
          _extends({}, validProps, {
            className: (0, _classnames2.default)("fe-navigation__link", { "fe-header-toggler--open fe-header-toggler--opened": this.props.open }),
            role: 'button',
            'aria-haspopup': true,
            'aria-expanded': this.props.open }),
          this.props.children
        );
      }if (this.props.dropdownType === 'avatar') {
        return _react2.default.createElement(
          'a',
          _extends({}, validProps, {
            className: (0, _classnames2.default)(classes, this.props.className),
            role: 'button',
            'aria-haspopup': true,
            'aria-expanded': this.props.open }),
          this.props.children
        );
      } else {
        return _react2.default.createElement(
          Component,
          _extends({}, validProps, {
            className: (0, _classnames2.default)(classes, this.props.className, { 'btn-dropdown': this.props.dropdownType === 'link' && this.props.open }),
            role: 'button',
            'aria-haspopup': true,
            'aria-expanded': this.props.open }),
          this.props.children || this.props.title,
          caret
        );
      }
    }
  }]);

  return DropdownToggle;
}(_react2.default.Component);

DropdownToggle.defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle',
  dropdownType: 'default',
  theme: 'default'
};

DropdownToggle.propTypes = {
  bsRole: _propTypes2.default.string,
  noCaret: _propTypes2.default.bool,
  open: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  useAnchor: _propTypes2.default.bool,
  dropdownType: _propTypes2.default.string,
  theme: _propTypes2.default.string
};

DropdownToggle.isToggle = true;
DropdownToggle.titleProp = 'title';
DropdownToggle.onClickProp = 'onClick';

exports.default = (0, _bootstrapUtils.bsClass)('dropdown', DropdownToggle);